import React from 'react';
import { Box, Typography } from '@mui/material';
// components 
import SelectDropdown from '../../../components/SelectDropdown';
import ErrorText from '../../../components/ErrorText';
import NoData from '../../../components/NoData';
import { ShimmerComponent } from '../../../components/Shimmer/ShimmerComponent';
import BouncingLogo from '../../../components/Shimmer/BouncingLogo';
import { CreativeListComponent } from './CreativeListComponent';
// hooks
import { useCreativeHook } from '../hooks/useCreativeHook';
// constants
import { CREATIVE_TYPE, FILTER_TYPES, MONTHS } from '../Constants';

const Creatives = _ => {
    const { options, userStores, isLoading, error, handleResetForFilters, resetFilter, yearsList, currentMonth, initialLoading, handleFilterChange, creativeData, urlMonth, urlYear, urlStoreId, urlCreativeType } = useCreativeHook();
    return ((userStores.length > 0) ? (
        <div style={{ height: '88vh', overflow: 'scroll', padding: '24px', paddingBottom: '100px' }}>
            <div style={{ width: 'fitContent', marginBottom: '20px' }}>
                <div
                    style={{
                        width: '100%',
                        textAlign: 'left',
                        margin: 'auto',
                        fontSize: '1.5rem',
                        fontWeight: '500',
                        lineHeight: '1.6',
                    }}
                >
                    Creatives
                </div>
            </div>
            <div
                style={{
                    boxSizing: 'border-box',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '13px',
                    width: '100%',
                    margin: 'auto',
                }}
            >
                <div style={{ marginRight: 'auto', display: 'flex', flexDirection: 'row', gap: '12px' }}>
                    {!initialLoading?.current ?
                        <SelectDropdown
                            options={options}
                            label={"Select Branch"}
                            resetValues={resetFilter}
                            handleResetValues={handleResetForFilters}
                            singleSelectDefaultValue={parseInt(urlStoreId) || options[0]?.value}
                            width={'200px'}
                            handleFilterChange={(e) => handleFilterChange(e, FILTER_TYPES.BRANCH)}
                            marginExist={false}
                            disabled={isLoading}
                        /> : <ShimmerComponent updatedStyle={{ width: '200px' }} />}
                    {!initialLoading?.current ?
                        <SelectDropdown
                            options={yearsList?.current || []}
                            label={"Select Year"}
                            resetValues={resetFilter}
                            handleResetValues={handleResetForFilters}
                            singleSelectDefaultValue={parseInt(urlYear) || yearsList?.current[0]?.value}
                            width={'100px'}
                            handleFilterChange={(e) => handleFilterChange(e, FILTER_TYPES.YEAR)}
                            marginExist={false}
                            disabled={isLoading}
                        /> : <ShimmerComponent />}

                    {!initialLoading?.current ?
                        <SelectDropdown
                            options={MONTHS}
                            label={"Select Month"}
                            resetValues={resetFilter}
                            handleResetValues={handleResetForFilters}
                            singleSelectDefaultValue={urlMonth ? MONTHS[parseInt(urlMonth) - 1]?.value :  MONTHS[currentMonth?.current-1]?.value}
                            width={'100px'}
                            handleFilterChange={(e) => handleFilterChange(e, FILTER_TYPES.MONTH)}
                            marginExist={false}
                            disabled={isLoading}
                        /> : <ShimmerComponent />}
                </div>

                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                    {!initialLoading?.current ?
                        <SelectDropdown
                            options={CREATIVE_TYPE}
                            label={"Select Type"}
                            resetValues={resetFilter}
                            handleResetValues={handleResetForFilters}
                            singleSelectDefaultValue={urlCreativeType || CREATIVE_TYPE[0]?.value}
                            width={'150px'}
                            handleFilterChange={(e) => handleFilterChange(e, FILTER_TYPES.CREATIVE_TYPE)}
                            marginExist={false}
                            disabled={isLoading}
                        /> : <ShimmerComponent updatedStyle={{ width: '150px' }} />}
                </div>
            </div>
            {error || !creativeData?.data?.length && !isLoading  && !initialLoading?.current && (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                    <NoData textValue={`${error ? 'Error loading data' : 'No data available'}`} />
                </Box>
            )}
            
            {isLoading || initialLoading?.current ? (
                <ShimmerComponent updatedStyle={{ width: '100%', height: '100%', backgroundSize: '2000px 800px', border: '0px' }} >
                    <BouncingLogo height='72vh' text='Loding...' />
                </ShimmerComponent>) :
               creativeData?.data?.length > 0 && (<div style={{ width: '100%', margin: 'auto', padding: '20px 0px' }}>
                    <Typography variant="h6" align='left' >Files</Typography>
                    <CreativeListComponent data={creativeData?.data} />
                </div>)
            }
        </div>
    ) :
        <div style={{ height: '88vh', overflow: 'scroll', padding: '24px', paddingBottom: '100px' }}>
            <div style={{ width: 'fitContent', marginBottom: '55px' }}>
                <div
                    style={{
                        width: '90%',
                        textAlign: 'left',
                        margin: 'auto',
                        fontSize: '1.5rem',
                        fontWeight: '500',
                        lineHeight: '1.6'
                    }}
                >
                    <ErrorText reason='No branches assigned to user' />
                </div>
            </div>
        </div>
    )
}

export default Creatives;